module.exports = __webpack_public_path__ + "static/media/whatsapp.51938695.svg";